import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["static"],
  _excluded2 = ["unmount"],
  _excluded3 = ["as", "children", "refName"];
import "core-js/modules/es.object.from-entries.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Fragment as T, cloneElement as x, createElement as E, forwardRef as b, isValidElement as h } from "react";
import { classNames as F } from './class-names.js';
import { match as P } from './match.js';
var S = function (a) {
    return a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a;
  }(S || {}),
  j = function (e) {
    return e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e;
  }(j || {});
function X(_ref) {
  var r = _ref.ourProps,
    t = _ref.theirProps,
    e = _ref.slot,
    a = _ref.defaultTag,
    s = _ref.features,
    _ref$visible = _ref.visible,
    n = _ref$visible === void 0 ? !0 : _ref$visible,
    f = _ref.name;
  var o = N(t, r);
  if (n) return c(o, e, a, f);
  var u = s != null ? s : 0;
  if (u & 2) {
    var _o$static = o.static,
      l = _o$static === void 0 ? !1 : _o$static,
      p = _objectWithoutProperties(o, _excluded);
    if (l) return c(p, e, a, f);
  }
  if (u & 1) {
    var _P;
    var _o$unmount = o.unmount,
      _l = _o$unmount === void 0 ? !0 : _o$unmount,
      _p = _objectWithoutProperties(o, _excluded2);
    return P(_l ? 0 : 1, (_P = {}, _defineProperty(_P, 0, function _() {
      return null;
    }), _defineProperty(_P, 1, function _() {
      return c(_objectSpread(_objectSpread({}, _p), {}, {
        hidden: !0,
        style: {
          display: "none"
        }
      }), e, a, f);
    }), _P));
  }
  return c(o, e, a, f);
}
function c(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var e = arguments.length > 2 ? arguments[2] : undefined;
  var a = arguments.length > 3 ? arguments[3] : undefined;
  var _g = g(r, ["unmount", "static"]),
    _g$as = _g.as,
    s = _g$as === void 0 ? e : _g$as,
    n = _g.children,
    _g$refName = _g.refName,
    f = _g$refName === void 0 ? "ref" : _g$refName,
    o = _objectWithoutProperties(_g, _excluded3),
    u = r.ref !== void 0 ? _defineProperty({}, f, r.ref) : {},
    l = typeof n == "function" ? n(t) : n;
  "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(t));
  var p = {};
  if (t) {
    var i = !1,
      m = [];
    for (var _i = 0, _Object$entries = Object.entries(t); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        y = _Object$entries$_i[0],
        d = _Object$entries$_i[1];
      typeof d == "boolean" && (i = !0), d === !0 && m.push(y);
    }
    i && (p["data-headlessui-state"] = m.join(" "));
  }
  if (s === T && Object.keys(R(o)).length > 0) {
    if (!h(l) || Array.isArray(l) && l.length > 1) throw new Error(['Passing props on "Fragment"!', "", "The current component <".concat(a, " /> is rendering a \"Fragment\"."), "However we need to passthrough the following props:", Object.keys(o).map(function (d) {
      return "  - ".concat(d);
    }).join("\n"), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map(function (d) {
      return "  - ".concat(d);
    }).join("\n")].join("\n"));
    var _i2 = l.props,
      _m = typeof (_i2 == null ? void 0 : _i2.className) == "function" ? function () {
        return F(_i2 == null ? void 0 : _i2.className.apply(_i2, arguments), o.className);
      } : F(_i2 == null ? void 0 : _i2.className, o.className),
      _y = _m ? {
        className: _m
      } : {};
    return x(l, Object.assign({}, N(l.props, R(g(o, ["ref"]))), p, u, w(l.ref, u.ref), _y));
  }
  return E(s, Object.assign({}, g(o, ["ref"]), s !== T && u, s !== T && p), l);
}
function w() {
  for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
    r[_key] = arguments[_key];
  }
  return {
    ref: r.every(function (t) {
      return t == null;
    }) ? void 0 : function (t) {
      var _iterator = _createForOfIteratorHelper(r),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var e = _step.value;
          e != null && (typeof e == "function" ? e(t) : e.current = t);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  };
}
function N() {
  var a;
  for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    r[_key2] = arguments[_key2];
  }
  if (r.length === 0) return {};
  if (r.length === 1) return r[0];
  var t = {},
    e = {};
  for (var _i3 = 0, _r = r; _i3 < _r.length; _i3++) {
    var s = _r[_i3];
    for (var n in s) n.startsWith("on") && typeof s[n] == "function" ? ((a = e[n]) != null || (e[n] = []), e[n].push(s[n])) : t[n] = s[n];
  }
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map(function (s) {
    return [s, void 0];
  })));
  var _loop = function _loop(_s) {
    Object.assign(t, _defineProperty({}, _s, function (n) {
      var o = e[_s];
      for (var _len3 = arguments.length, f = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        f[_key3 - 1] = arguments[_key3];
      }
      var _iterator2 = _createForOfIteratorHelper(o),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var u = _step2.value;
          if ((n instanceof Event || (n == null ? void 0 : n.nativeEvent) instanceof Event) && n.defaultPrevented) return;
          u.apply(void 0, [n].concat(f));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }));
  };
  for (var _s in e) {
    _loop(_s);
  }
  return t;
}
function D(r) {
  var t;
  return Object.assign(b(r), {
    displayName: (t = r.displayName) != null ? t : r.name
  });
}
function R(r) {
  var t = Object.assign({}, r);
  for (var e in t) t[e] === void 0 && delete t[e];
  return t;
}
function g(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var e = Object.assign({}, r);
  var _iterator3 = _createForOfIteratorHelper(t),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var a = _step3.value;
      a in e && delete e[a];
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return e;
}
export { S as Features, j as RenderStrategy, R as compact, D as forwardRefWithAs, X as render };